export default __webpack_public_path__ + "static/media/Group759.3db8858a.svg";